import en from '../../content/i18n/en.json';
import fr from '../../content/i18n/fr.json';

export type Locale = 'fr' | 'en';

const dictionaries: Record<Locale, Record<string, string>> = { fr, en };
let current: Locale = 'fr';

/** Traduit une clé dans la langue courante (retombe sur le français). */
export function t(key: string): string {
  return dictionaries[current][key] ?? dictionaries.fr[key] ?? key;
}

export function getLocale(): Locale {
  return current;
}

/** Applique les traductions aux éléments `data-i18n*` sous `root`. */
export function applyTranslations(root: ParentNode = document): void {
  root.querySelectorAll<HTMLElement>('[data-i18n]').forEach((element) => {
    element.textContent = t(element.dataset.i18n ?? '');
  });
  root.querySelectorAll<HTMLElement>('[data-i18n-title]').forEach((element) => {
    element.title = t(element.dataset.i18nTitle ?? '');
  });
  root.querySelectorAll<HTMLElement>('[data-i18n-placeholder]').forEach((element) => {
    if (element instanceof HTMLInputElement) {
      element.placeholder = t(element.dataset.i18nPlaceholder ?? '');
    }
  });
  root.querySelectorAll<HTMLElement>('[data-i18n-aria]').forEach((element) => {
    element.setAttribute('aria-label', t(element.dataset.i18nAria ?? ''));
  });
}

export function setLocale(locale: Locale): void {
  current = locale;
  applyTranslations();
}
